import React, { useEffect, useState } from 'react';

import classes from './like.module.scss';

import HeartSVG from '@/assets/svg/heart.svg';
import clsx from 'clsx';
import { PublicPath } from '@/utils/constant';
import { observer } from 'mobx-react';
import { useStorage } from '@/models/Storage';

export const Like = observer(({ storyId, amount }) => {
    const { userLikes, setUserLikes } = useStorage();
    const toggleLike = () => {
        fetch(`${PublicPath}/api/toggleLike`, {
            method: 'POST',
            body: JSON.stringify({
                puid: localStorage.getItem('mskhpuid'),
                storyId: storyId,
            }),
        }).then(() => {
            fetch(`${PublicPath}/api/getUserLikes`, {
                method: 'POST',
                body: JSON.stringify({ puid: localStorage.getItem('mskhpuid') }),
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data) {
                        setUserLikes(data);
                    }
                });
        });
    };

    const [active, setActive] = useState(false);

    useEffect(() => {
        setActive(userLikes.includes(storyId));
    }, [userLikes.length]);

    return (
        <div className={clsx(classes.like, active && classes.active)}>
            <button
                onClick={() => {
                    toggleLike();
                }}
            >
                <HeartSVG />
            </button>
            <span>{amount || 0}</span>
        </div>
    );
});
